import React from 'react'

import { useSaveBuckets } from './_requests/createBucket'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'

const BucketForm = () => {
  const [save, { loading, error }] = useSaveBuckets()

  return (
    <Form loading={loading} onSubmit={save} initialState={{}}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default BucketForm
